<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div col-11">
      <h5 class="mt-3 mb-3"> Legal </h5>
      <div>
        <center>
          <h6>FACIT DATA SYSTEMS LIMITED - END USER SOFTWARE LICENSE AGREEMENT (EULA) <br />
            17thst May 20186 VERSION
          </h6>
        </center>
        <p>This EULA sets out the scope and terms of a licence for the Software described
            in this EULA. The Software is licensed, not sold.
        </p>
        <p>
          With the exception Free Third Party Software referred to in clause 1.6 below
          (and in respect of which specific terms apply), The Software was produced by,
          is licensed by, and is © Copyright Facit Data Systems Limited (from September 1st 2014)
          (referred to as <strong>"Facit"</strong> or the <strong>"Licensor"</strong>), a company
          registered in England and Wales with company number 09090054 and with registered
          office Atlantic House 8 Bell Lane, Bellbrook Industrial Estate, Uckfield,
          East Sussex, England, TN22 1QL.THE LICENSEE'S ATTENTION IS DRAWN TO
          CLAUSE 8 WHICH EXCLUDES ALL WARRANTIES AND ALL THE LIABILITY OF THE
          LICENSOR (AND ITS LICENSORS) WITH RESPECT TO THE SOFTWARE.
          This EULA shall not override any provisions of the governing law of
          this EULA, or of any local law of the Licensee, where such law specifies
          that such provisions cannot be derogated from by agreement or notice, or
          makes it an offence to do so.THE LICENSEE SHALL BE DEEMED TO HAVE AGREED
          TO THE TERMS OF THIS EULA, BY EITHER (A) RUNNING THE SOFTWARE, OR DOING
          ANYTHING TO ACTIVATE THE SOFTWARE, INCLUDING APPLYING ANY LICENSE KEY;
          OR (B) DOING ANYTHING TO INDICATE ACCEPTANCE OF THIS EULA, SUCH AS BY
          CLICKING ANY BUTTON OR CHECKBOX INDICATING ACCEPTANCE IN ANY FORM IN
          WHICH THIS EULA IS PRESENTED TO THE LICENSEE.
        </p> <br />
        <strong>TABLE OF SECTIONS</strong> <br />
        <p>
          1. Scope <br />
          2. Licensor <br />
          3. Licensee <br />
          4. License Keys <br />
          5. Formation of License <br />
          6. Grant of License <br />
          7. License Terms <br />
          8. Exclusion And Limitation Of Liability <br />
          9. Termination <br />
          10. Entire Agreement <br />
          11. No Waiver <br />
          12. Governing Law And Jurisdiction<br />
        </p> <br />
        <strong>1. SCOPE </strong> <br />
        <div>
          <p>
            <strong>1.1 The Software  </strong> <br />
            <p>The Licencse is granted with respect to the Facit video analyticsIdentity
              Cloak software and any associated user documentation and interface
              (the "Software") with which this EULA is supplied or in respect of which
              this EULA is presented or applied.
            </p>
            <strong>1.2 Purchase Order</strong> <br />
            <p>
              References in this EULA to the "Purchase Order" are to the agreement
              under which the Software and this Licencse was agreed to be supplied,
              which may be an agreement with any distributor, agent or reseller of Facit.
            </p>
            <strong>1.3 Installation Device    </strong> <br />
            <p>
              The Licencse is granted to run the Software on the camera, computer
              server or other device (the "Installation Device") which is either:
              (a) referenced in the Purchase Order;
              (b) linked to any Licencse Key supplied for the Software; or
              (c) the camera or other device on which the Software came pre-installed at
              the time of first purchase as new. Where the Installation Device is a camera,
              then this is referred to as the "Installation Camera" in this EULA.
            </p>
            <strong> 1.4 Installation Device Identifiers </strong> <br />
            <p>
              The Installation Device may be identified by reference to its MAC
              (media access control) address, any serial number, and/or any other
              information stored on or uniquely identifying the Installation Device
              ("Installation Device Identifiers").
            </p>
            <strong> 1.5 Updates </strong> <br />
            <p>
              This Licencse extends to any updates and new versions of the Software,
              with associated Licencse Keys, which may be supplied to the Licensee
              from time to time, for installation on the Installation Device.
            </p>
            <strong> 1.6 Free Third Party Software <br /> <br />
              1.6.1 General provisions applicable to Third Party Software </strong> <br />
              <p>
                Where the Licensor supplies to the Licensee any Free Third Party Software,
                or the Software links to, incorporates, or otherwise uses any Free Third
                Party Software, then this Licence does not cover such Free Third Party
                Software, and nothing in this Licence shall restrict the Licensee from
                exercising any rights it may have under any Free Third Party Software Licence.
                "Free Third Party Software" means any software or other materials produced
                and made available to the public by a third party under a Free Third Party
                Software Licence, and a "Free Third Party Software Licence" means a licence
                of software or other materials granted generally to the public in relation
                to any software for which no licence fee is charge (such as software licensed
                under the General Public Licence, Lesser General Public Licence (“LGPL”),
                BSD Licence, MIT/X Licence, Open SSLicence (including the Open SSLeay License)
                Mozilla Public Licence, and Apache Licence).
              </p>
              <strong> 1.6.2 Specific provisions applicable to Third Party Software </strong> <br />
              <p>
                For clarity, the Licensor has set out the applicable Free
                Third Party Software Licences below:
                (A)  This Software uses to libraries from the Libav project which are licensed
                under the LGPLv2.1.The Licensor does not own such libraries and any prohibition
                on reverse engineering those libraries set out in this EULA does not apply to
                them.Libav can be contacted at https://www.libav.org.
                (B) This software uses libraries from the FFmpeg project which are
                licensed under the LGPLv2.1.  The Licensor does not own such libraries
                and any prohibition on reverse engineering those libraries set out in
                this EULA does not apply to them.  FFmpeg can be contacted at http://ffmpeg.org/.
                (C)The Software also utilises OpenSSL which is subject to a licence
                pursuant to both the Open SSLicence and the original SSLeay licence.
                Open SSL is copyright (c) 1998-2018 The OpenSSL Project and
                copyright © 1995-1998 Eric Young (eay@cryptsoft.com).
                All rights reserved. This product includes software developed by the
                OpenSSL Projectfor use in the OpenSSL Toolkithttp://www.openssl.org/)
                and software written by Tim Hudson (tjh@cryptsoft.com).  The full text
                of the Free Third Party Software Licence applicable to Open SSL has
                been set out in the Appendix below.
                (D)  The Software also utilises headings and functions from CURL
                and links to the CURL library.  This is subject to the copyright
                notices and licence set out below:
                “COPYRIGHT AND PERMISSION NOTICE
                Copyright (c) 1996 - 2018, Daniel Stenberg, daniel@haxx.se, and many
                contributors, see the THANKS file.
                All rights reserved.
                Permission to use, copy, modify, and distribute this software for any
                purpose with or without fee is hereby granted, provided that the above
                copyright notice and this permission notice appear in all copies.
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF THIRD PARTY RIGHTS.
                IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                USE OR OTHER DEALINGS IN THE SOFTWARE.
                Except as contained in this notice, the name of a copyright holder shall
                not be used in advertising or otherwise to promote the sale, use or other
                dealings in this Software without prior written
                authorization of the copyright holder.”
              </p>
          </div>
          <div>
            <strong>2. LICENSOR </strong><br />
            <p>
              The Licencse is granted by Facit Data Systems Limited (the "Licensor").
            </p>
          </div>
          <div>
            <strong>3. LICENSEE  </strong><br />
            <p>
              The Licencse is granted to the individual or legal entity who is identified
              as the customer in the Purchase Order (if any), or in any other case, the
              owner for the time being of the Installation Device Camera, (the "Licensee").
              If (a) ownership of the Installation Device is sold by the Licensee or otherwise
              transferred by the Licensee to a third party, or (b) the Licensee transfers or
              purports to transfer the Software, the EULA and/or License Keys for the Software
              to a third party, or (c) the Installation Device, Software, EULA or License Keys
              are transferred by operation of law to a third party, then: the Licencse shall
              terminate with respect to the Licensee, and a new offer of a Licencse under
              Clause 5.1 below, is made to such third party, which may be accepted by such
              third party in accordance with the terms of this EULA, and upon such acceptance,
              such third party shall become the Licensee. </p>
            </div>
            <div>
              <strong>4. LICENSE KEYS  </strong><br />
              <p>
                A licence key or keys (which is a special number), issued by or on behalf
                of the Licensor, shall be required to use the Software on the Installation
                Device (the "License Key") and the Software will not operate on the Installation
                Device without a License Key or Keys for the Installation Device. The License Key
                will be linked to the Installation Device Identifiers specified above, so that the
                Software cannot be used except on an Installation Device that has the same
                Installation Device Identifiers as those used to generate the License Key.
                The Software shall accordingly not be used without an official License Key or
                Keys issued by or on behalf of the Licensor. The Licensee must obtain a
                License Key or Keys from the person who agreed the Purchase Order with
                the Licensee, and the Licensor is not itself obliged to supply the License
                Key unless the Licensor was itself party to the Purchase Order. The Licencse
                under this EULA will not be granted except to a person who has been supplied
                a valid License Key or Keys.
              </p>
            </div>
            <div>
              <strong> 5. FORMATION OF LICENSE  </strong><br /> <br />
              <strong> 5.1 Offer from Licensor   </strong><br />
              <p>
                This EULA represents notice to the Licensee of the terms on which
                the Software is licensed, and an offer from the Licensor to the Licensee
                to licence the Software on the terms of this EULA. The Licensee shall
                not be entitled to use the Software, and the Licencse shall not be granted
                and may not be exercised, unless and until the Licensee has accepted and
                agreed to this EULA.
              </p>
              <strong> 5.2 Acceptance from Licensee  </strong>
              <p>
                The Licensee shall be deemed to have accepted the above offer in Clause 5.1,
                and to have agreed to the terms of this EULA, by either: (a) installing
                the Software; (b) running the Software on the Installation Device; (c)
                doing anything to activate the Software, including applying any
                License Key; or (d) doing anything else to indicate acceptance of this
                EULA, such as by clicking any button or checkbox indicating acceptance
                in any form in which this EULA is presented to the Licensee. Any officer,
                employee, agent, consultant or contractor who purports to accept and agree
                to this EULA on behalf of the Licensee shall be deemed to have authority
                to do so. Acceptance by the Licensee of this EULA shall create a
                legally binding agreement on the terms of this EULA.
              </p>
              <strong> 5.3 Non-Acceptance  </strong>
              <p>
                The Software shall not be used except by a person who has accepted
                and agreed to this EULA with the Licensor. If the Licensee does not
                accept and agree to this EULA then the Licensee should speak to the
                other party to the Purchase Order about their returns policy.
              </p>
            </div>
            <div>
              <strong> 6. GRANT OF LICENSE  </strong> <br />
              <p>
                The Licensee is granted by the Licensor a non-exclusive licence to:
                (a) store, load, and run a single instance of the Software on the
                Installation Device; and
                (b) to copy any user documentation or interface, incidental to
                viewing or using the same in a web-browser, in connection with the
                use of the Software (the "Licensce"). The Licencse is granted on and
                subject to the terms of this EULA, and is conditional on the Licensee
                complying with all the terms of this EULA.
              </p>
            </div>
            <div>
              <strong> 7. LICENCSE TERMS  </strong><br /> <br />
              <strong> 7.1 Duration  </strong><br />
              <p>
                (a) Trial License <br />
                If the Software supplied is for trial purposes, or the Licence or
                Licence Key is identified in the Purchase Order as being a trial
                licence or trial licence key,  then:
                (i) the Software shall only be used by the Licensee to trial and
                evaluate the Software to enable it to make a decision as to
                whether to purchase a full licence;
                (ii) this License shall last for 3 months7 calendar days from the
                date of supply of the Software or Installation Device on which the
                Software came installed, and the Software will cease to operate and
                shall cease to be used when such period and the associated License
                Key has expired; and
                (iii) this Licensce shall not be transferrable and the Software
                shall not be used for any other purposes.
                <br />
                (b) Demonstration Perpetual License
                <br />
                If the Software is supplied for demonstration purposes, or the
                Licence or Licence Key is identified in the Purchase Order as
                being a demonstration licence or demonstration licence key, then:
                (i) the Software shall only be used by the Licensee for the purposes
                of demonstrating the Software to customers of the Licensee:
                (ii) this License shall run from acceptance under Clause 5.2 and
                continue without limit of time subject to earlier termination in
                accordance with any other term of the EULA; and
                (iii) this License shall not be assignable or transferable and
                the Software shall not be used for any other purposes.
                <br />
                (c) Commercial Perpetual Licencse
                <br />
                Except where Clause 7.1(a) or(b) applies, or if the Licence or
                Licence Key is identified in the Purchase Order as being a commercial
                perpetual licence or commercial perpetual licence key, then:
                (i) the Software may be used for the internal business purposes of the
                Licensee, without the restrictions under 7.1(a) or (b); and
                (ii) the Licensce shall run from acceptance under Clause 5.2
                and continue for twelve months without limit of time subject to
                earlier termination in accordance with any other term of the EULA.
                At the end of the twelve month period, the Licence Key will expire.
                In order to continue to use Software the Licensee must contact the
                Licensor to acquire a new Licence Key which will, subject to the other
                terms of this EULA extend the Licence for a further twelve months.
              </p>
              <strong> 7.2 Installation Device   </strong>
              <p>
                The Software may and shall only be used on, and shall only be kept on:
                (a) the Installation Device on which it came pre-installed at the time
                of first purchase of the Installation Device as new; or
                (b) if the Software did not come pre-installed, on the Installation
                Device corresponding to the Installation Device Credentials used to
                generate the License Key; or (c) in any other case, on such Installation
                Device as may have been approved in writing in the
                Purchase Order or by the Licensor.
              </p>
              <strong> 7.3 Permitted Use  </strong>
              <p>
                The Software may and shall only be used on the Installation Device
                for the internal business purposes of the Licensee, and such use shall
                be subject to any restrictions in Clause 7.1. The Software shall only be
                operated by officers, employees, agents, consultants and contractors
                employed or engaged by and acting on behalf of the Licensee
                ("Representatives"). The Licensee acknowledges that the Software is
                only designed to be deployed and function in an indoor or internal
                environment with stable lighting conditions.
              </p>
              <strong> 7.4 Quantity of Use  </strong>
              <p>
                If the Software is for installation on or comes pre-installed on
                an Installation Camera, then the Software may only be used for that
                Installation Camera and the video feed for that Installation Camera.
                In any other case the Software may only be used at the sites and for
                the number of identified cameras specified in the Purchase Order.
              </p>
              <strong> 7.5 Territory  </strong>
              <p>
                The Software may and shall only be used in the country in or to
                which the Software (or Installation Device on which it came pre-installed)
                was first supplied as new, or as may be specified in the Purchase Order.
              </p>
              <strong> 7.6 No Transfer </strong>
              <p>
                The Licencse may not be assigned, transferred, charged, held in trust,
                or otherwise dealt with by the Licensee. See Clause 3 for details on
                what happens in the event of transfers.
              </p>
              <strong> 7.7 No Copying  </strong>
              <p>
                The Software may not and shall not be copied, except for: <br />
                (a) such copying as may be required to install the Software on the
                Installation Device; <br />
                (b) such copying as may happen automatically within the Installation
                Device as part of the running of the Software on the Installation Device;
                <br />
                (c) any automatic copying of any html documentation or user interface
                web pages to a web browser cache which is incidental to accessing and
                browsing the documentation or user interface to the Software. Accordingly,
                except as provided in the previous sentence, no copy of the Software shall
                be removed from the Installation Device.
              </p>
              <strong> 7.8 Sub-Licensing </strong>
              <p>
                The Licensee may not and shall not grant sub-licences under the Licencse. </p>
                <strong> 7.9 All other rights reserved  </strong>
                <p>
                  Except for the Licencse, no other licence, right or permission is granted
                  by the Licensor with respect to the Software. All implied licences, rights
                  and permissions with respect to the Software are hereby excluded.
                </p>
                <strong> 7.10 General prohibition on unlicensed use   </strong>
                <p>
                  Except for the acts explicitly authorised by the Licensec under Clause
                  6(GRANT OF LICENCSE) and the other terms of this Clause
                  7(LICENCSE TERMS), the Licensee is prohibited from doing anything and
                  shall not do anything with respect to the Software, and in particular
                  (without limitation) the Licensee is prohibited from doing and shall not
                  itself or permit any other person to do or attempt to do any of the following:
                  (a) publish, copy, rent, lease, sub-license,
                  loan, translate, or adapt the Software;
                  (b) transfer the Software (except as permitted by this EULA);
                  (c) work around any technical restrictions or limitations in the Software which
                  prevent it being used other than in accordance with the Licensce on the
                  Installation Device, including creating or modifying License Keys;
                  (d) make alterations to, or modifications of, the whole or any part
                  of the Software;
                  (e) combine all or any part of the Software in any other programs;
                  (f) use the Software separately from the Installation Camera Deviceor
                  in respect of any video feed other than one captured by Installation
                  Camera itself; and
                  (g) (save as provided in clause 1.6.2 in respect of Free Third
                  Party Software (which does not form part of the Software and in respect
                  of which separate licensing provisions apply) disassemble, de-compile,
                  reverse engineer or create derivative works based on the whole or any
                  part of the Software.
                </p>
                <strong> 7.11 Security  </strong>
                <p>
                  The Licensee shall take appropriate measures to protect the Software
                  from being stolen (including any copy on the Installation Device),
                  and against use of the Software outside the scope of the Licensce
                  and contrary to the terms of the Licensce, and against the Software
                  being copied other than as explicitly permitted by this EULA.
                </p>
                <strong> 7.12 Confidentiality  </strong>
                <p>
                  The Licensee acknowledges that the Software is confidential
                  to the Licensor and shall keep the Software confidential and
                  not disclose the same to any person other than in confidence
                  to any Representatives, where such disclosure is within the
                  Installation Device and incidental to the use of the Software
                  within the Installation Device.
                </p>
                <strong> 7.13 Intellectual Property Rights   </strong>
                <p>
                  The Licensee acknowledges and agrees that all Intellectual
                  Property Rights in and to the Software and any trade-marks and
                  trade names belong to the Licensor absolutely, that:
                  (a) rights in the Software are licensed (not sold)
                  to the Licensee under this EULA;
                  (b) the Licensee has no rights in or to the Software, other than
                  the right to use it under the License in accordance
                  with the terms of this EULA; and
                  (c)  the Licensee has no rights in relation to any trade-marks
                  or trade names of the Licensor. The Licensor reserves all rights
                  in relation to the Software not expressly granted in this EULA.
                  The Licensee shall not amend, delete or obscure any copyright notice,
                  trade marks or other proprietary notices appearing in or with the Software.
                  In this EULA "Intellectual Property Rights" means any and all intellectual
                  property rights in any part of the world including copyrights, moral
                  rights, lending rights, rights in databases, rights in performances,
                  design rights, rights in inventions, patents, registered design
                  rights, trade marks, passing-off rights, in each case whether
                  registered or unregistered and including all rights to apply for
                  and in applications for the grant, renewal, extension or right to
                  claim priority from such rights, rights to sue for infringements,
                  and all similar or analogous rights or forms of protection which
                  subsist or will subsist now or in the future in any part of the world.
                </p>
                <strong> 7.14 Source Code   </strong>
                <p>
                  The License only extends to the actual Software in the form in which
                  it is supplied to the Licensee, and does not extend to any source code
                  for the Software or any other form of the Software not supplied to the
                  Licensee, and does not give any right to access the Software in source
                  code form or in unlocked coding or with comments.
                  Different provisions may apply in respect of access to source code
                  ofFree Third Party Software which are separately detailed in this Licence
                  or the relevant Free Third Party Software Licence.
                </p>
                <strong> 7.15 Legal Compliance  </strong>
                <p>
                  The Licensee shall observe and comply with all applicable laws
                  concerning its use of the Software and the Free Third Party Software
                  in any jurisdiction in which it uses the Software and the Free Third
                  Party Software. The Licensee shall comply with all applicable import
                  and export laws relating to the Software and Free Third Party Software
                  when importing or exporting the Software and Free Third Party Software
                  or the Installation Device containing the Software.
                </p>
              </div>
              <div>
                <strong> 8. EXCLUSION AND LIMITATION OF LIABILITY   </strong><br /> <br />
                <strong> 8.1 Non-Excluded Liability </strong>
                <p>
                  Nothing in this License excludes or limits the following Liability
                  of the Licensor: (a) any Liability for death or personal injury resulting
                  from the Licensor's negligence; (b) any Liability for fraud or fraudulent
                  misrepresentation committed by the Licensor; or (c) any Liability to the
                  extent that it may not be excluded or limited by law, or any such exclusion
                  or limitation would be an offence.
                </p>
                <strong> 8.2 All other Liability Excluded   </strong>
                <p>
                  Except as provided in Clause 8.1, the Licensor excludes any and all
                  Liability to the Licensee with respect to or arising in any way in
                  connection with this EULA, the Software or the use of the Software.
                </p>
                <strong> 8.3 Licensee's Risk  </strong>
                <p>
                  Except as provided in Clause 8.1, the Software is licensed "as is"
                  and the Licensee agrees that it uses the Software at its sole and
                  entire risk, and the Licensee acknowledges that the Software has not
                  been developed to or promised to meet the Licensee's individual requirements.
                </p>
                <strong> 8.4 No Warranties   </strong>
                <p>
                  No promise, guarantee, agreement, term, condition or warranty is
                  given by the Licensor under this EULA that the Software shall: <br />
                  (i) meet any Standard;  or <br />
                  (ii) be Non-Infringing. <br />
                  All promises, guarantees, agreements, terms, conditions and
                  warranties with respect to the Software or its Standard or Non-Infringement,
                  which are implied by law, custom, convention, course of dealing, or otherwise
                  howsoever, in favour of the Licensee, are hereby excluded to the fullest
                  extent permitted by law. References to:
                  (a) "Standard" include its merchantability,
                  quality, performance, fitness for purpose, and compliance with any description,
                  sample, model, or evaluation version; and
                  (b) "Non-Infringing" or "Non-Infringement"
                  are to the Software or its import, export, sale, transfer, copying, or use under
                  the Licencse not infringing any Intellectual Property Rights of any third party
                  in all or any part of the world.
                </p>
                <strong> 8.5 No Duty of Care    </strong>
                <p>
                  Except as provided in Clause 8.1, no duty of care is assumed by the
                  Licensor to the Licensee or anyone else using the Software or
                  Installation Device, and any and all Liability for negligence
                  and negligent misstatement is excluded.
                </p>
                <strong> 8.6 Non-Contractual Claims  </strong>
                <p>
                  Except as provided in Clause 8.1, all non-contractual claims,
                  rights, causes of action and remedies of the Licensee against the
                  Licensor with respect to the Software, the License or this EULA are
                  hereby excluded.
                </p>
                <strong> 8.7 Use outside terms of lLicence  </strong>
                <p>
                  Except as provided in Clause 8.1, the Licensor shall not have
                  any Liability to the Licensee for any loss, damage or liability
                  which the Licensee or any third party may suffer or incur if the
                  Software is used outside the terms of the Licencse, or outside of
                  the country referred to in Clause 7.5(Territory).
                </p>
                <strong>  8.8 Excluded Types of Loss   </strong>
                <p>
                  Except as provided in Clause 8.1, the Licensor shall not in any
                  circumstances be Liable to the Licensee for any of the following
                  (whether direct loss or indirect or consequential loss):
                  (a) loss of profits, sales, business, or revenue;
                  (b) business interruption;
                  (c) loss of anticipated savings;
                  (d) loss or corruption of data or information;
                  (e) loss of business opportunity, goodwill or reputation; or
                  (f) loss which would have been prevented had the Software functioned
                  as expected, intended or required. Except as provided in Clause 8.1,
                  the Licensor shall not in any circumstances be Liable to the Licensee
                  for any special, indirect or consequential loss or damage or punitive damages.
                </p>
                <strong> 8.9 Cap  </strong>
                <p>
                  Except for the liability covered by Clause 8.1, the Licensor's
                  total Liability shall be limited to £500 for all causes of action
                  in the aggregate. Except for the liability covered by Clause 8.1,
                  and without prejudice to the previous sentence, the Licensor's total
                  Liability shall be limited to £250 for any single cause of action.
                </p>
                <strong> 8.10 References to Liability   </strong>
                <p>
                  References in this EULA to any "Liability" of the Licensor shall
                  be to any liability for:
                  (a) breach of the EULA;
                  (b) negligence under or in connection with this EULA or the Software;
                  (c) liability for breach of or imposed by any legislation or law;
                  (d) liability arising out of any non-contractual cause of action relating
                  to or connected in any way with this EULA or the Software;
                  (e) liability for misrepresentation (other than fraudulent misrepresentation); or
                  (f) any other liability or cause of action of
                  whatever nature arising in connection with this EULA or the Software.
                </p>
              </div>
              <div>
                <strong> 9. TERMINATION </strong>
                <p>
                  The Licencse shall terminate automatically if the Licensee commits any
                  Breach. "Breach" means any breach of this EULA, or anything done with
                  respect to the Software by the Licensee or any third party which is not
                  authorised by the License, however trivial the breach or thing done,
                  except for a trivial accidental breach or action where the Licensee
                  has used reasonable endeavours to perform this EULA in that respect.
                </p>
              </div>
              <div>
                <strong> 10. ENTIRE AGREEMENT </strong>
                <p>
                  This EULA constitutes the entire scope and terms of the licence
                  granted in respect of the Software and the entire agreement between
                  the Licensor and Licensee. The Licensee acknowledges that they have
                  not relied on any statement, promise or representation
                  in entering into this EULA.
                </p>
              </div>
              <div>
                <strong> 11. NO WAIVER  </strong>
                <p>
                  If the Licensor fails to insist that the Licensee performs any of
                  their obligations under this EULA, or if they do not enforce their
                  rights against the Licensee, or if the Licensor delays in doing so,
                  that will not mean that the Licensor has waived their rights against
                  the Licensee and will not mean that the Licensee does not have to
                  comply with those obligations. If the Licensor does waive a default
                  by the Licensee, they will only do so in writing, and that will not
                  mean that the Licensor will automatically waive any later
                  default by the Licensee.
                </p>
              </div>
              <div>
                <strong> 12. GOVERNING LAW AND JURISDICTION   </strong> <br />
                <strong> 12.1 Governing Law </strong>
                <p>
                  The Licencse, this EULA, and all Claims shall be exclusively
                  governed by the laws of England and Wales, except that this shall
                  be without prejudice to any non-contractual cause of action which
                  the Licensor may have against the Licensee under any other laws
                  arising out of any act or omission of the Licensee
                  outside England and Wales.
                </p>
                <strong> 12.2 Jurisdiction </strong>
                <p>
                  Except as provided in the second sentence of this Clause, the
                  Licensor and Licensee agree that the courts of England and Wales
                  shall have exclusive jurisdiction over all Claims, and agree not
                  to commence any legal action in any other courts concerning any
                  Claim. Notwithstanding the previous sentence, the Licensor shall
                  be entitled to commence legal proceedings in respect of any Claim
                  in the courts of any country or jurisdiction in the world where the
                  Licensee is established, has any assets, or commits any of the acts
                  or omission forming part of the basis of the Claim, and if the
                  Licensor does so, then the Licensee may bring counter-Claims in
                  the same legal proceedings.
                </p>
                <strong> 12.3 Claims  </strong>
                <p>
                  References to "Claims" mean any cause of action, remedies,
                  liability, questions, and disputes (whether contractual or non-contractual)
                  arising under or in connection with the Software, the License or this
                  EULA, including as to the formation and governing
                  law of the License or this EULA.
                </p>
                <strong>13. Third party rights</strong>
                <p>
                  No one other than a Licensee has any right to enforce any term of this Licence.
                 </p>
               </div>
               <div>
                 <strong > APPENDIX to Licence to the Software </strong> <br />
                 <p>
                   Free Third Party Software Licence Conditions
                   Applicable to Open SSL <br />
                   The OpenSSL toolkit is subject to a double license, i.e.
                   both the conditions of the OpenSSL License and the original
                   SSLeay license apply to the toolkit.
                   <br />
                 </p>
                 <strong>Open SSL Licence </strong> <br />
                 <p>
                   Copyright (c) 1998-2018 The OpenSSL Project.  All rights reserved. <br />
                   Redistribution and use in source and binary forms, with or
                   withoutmodification, are permitted provided that the following
                   conditionsare met:
                   <br />
                   1. Redistributions of source code must retain the above copyrightnotice,
                   this list of conditions and the following disclaimer.
                   <br />
                   2. Redistributions in binary form must reproduce the above copyrightnotice,
                   this list of conditions and the following disclaimer inthe documentation
                   and/or other materials provided with the distribution.
                   <br />
                   3. All advertising materials mentioning features or use of thissoftware
                   must display the following acknowledgment: "This product includes
                   software developed by the OpenSSL Project for use in the OpenSSL
                   Toolkit. (http://www.openssl.org/)"
                   <br />
                   4. The names "OpenSSL Toolkit" and "OpenSSL Project" must not be
                   used to endorse or promote products derived from this software without
                   prior written permission. For written permission,
                   please contactopenssl-core@openssl.org.
                   <br />
                   5. Products derived from this software may not be called "OpenSSL"
                   nor may "OpenSSL" appear in their names without prior written permission
                   of the OpenSSL Project.
                   <br />
                   6. Redistributions of any form whatsoever must retain the following
                   acknowledgment: "This product includes software developed by the
                   OpenSSL Project for use in the OpenSSL Toolkithttp://www.openssl.org/)"
                   <br />
                   THIS SOFTWARE IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND
                   ANY EXPRESSED OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
                   THEIMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
                   PARTICULARPURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE OpenSSL
                   PROJECT ORITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
                   INCIDENTAL,SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
                   (INCLUDING, BUTNOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
                   SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
                   HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
                   STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING
                   IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
                   POSSIBILITY OF SUCH DAMAGE.
                   <br />
                   * This product includes cryptographic software written by
                   Eric Young(eay@cryptsoft.com).  This product includes software written
                   by TimHudson (tjh@cryptsoft.com).
                 </p>
                 <strong>Original SSLeay License </strong>
                 <p>
                   Copyright (C) 1995-1998 Eric Young (eay@cryptsoft.com)
                   <br />
                   All rights reserved.This package is an SSL implementation writtenby
                   Eric Young (eay@cryptsoft.com).The implementation was written so as
                   to conform with Netscapes SSL.This library is free for commercial
                   and non-commercial use as long asthe following conditions are aheared to.
                   The following conditionsapply to all code found in this distribution,
                   be it the RC4, RSA,lhash, DES, etc., code; not just the SSL code.
                   The SSL documentationincluded with this distribution is covered by
                   the same copyright termsexcept that the holder is
                   Tim Hudson (tjh@cryptsoft.com).
                   Copyright remains Eric Young's, and as such any Copyright notices
                   in the code are not to be removed.If this package is used in a
                   product, Eric Young should be given attributionas the author of
                   the parts of the library used. This can be in the form of a textual
                   message at program startup or
                   in documentation (online or textual) provided with the package.
                   Redistribution and use in source and binary forms, with or without
                   modification, are permitted provided that the following conditions
                   are met:
                   <br />1. Redistributions of source code must retain the copyrightnotice,
                   this list of conditions and the following disclaimer.
                   <br />2. Redistributions in binary form must reproduce the above copyright
                   notice, this list of conditions and the following disclaimer in the
                   documentation and/or other materials provided with the distribution.
                   <br />3. All advertising materials mentioning features or use of this
                   software must display the following acknowledgement:"This product includes
                   cryptographic software written byEric Young (eay@cryptsoft.com)"
                   <br />
                   The word 'cryptographic' can be left out if the rouines from the
                   librarybeing used are not cryptographic related :-).
                   <br />4. If you include any Windows specific code (or a derivative thereof)
                   from the apps directory (application code) you must include an acknowledgement:
                   "This product includes software written by Tim Hudson (tjh@cryptsoft.com)"
                   THIS SOFTWARE IS PROVIDED BY ERIC YOUNG ``AS IS'' ANDANY EXPRESS OR IMPLIED
                   WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THEIMPLIED WARRANTIES OF
                   MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSEARE DISCLAIMED.
                   IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLEFOR ANY DIRECT,
                   INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIALDAMAGES
                   (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODSOR
                   SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
                   HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
                   STRICTLIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING
                   IN ANY WAYOUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
                   POSSIBILITY OFSUCH DAMAGE.
                   <br />
                   The licence and distribution terms for any publically available
                   version orderivative of this code cannot be changed.  i.e. this
                   code cannot simply becopied and put under another distribution
                   licence[including the GNU Public Licence.]
                 </p>
                 <p>Basic, Standard and Premium Packages are sold on the clear understanding that
                   they can not be resold or marketed as a service to a third party.<br>
                   Breaching of this clause will lead to the cancellation of access to the
                   platform and loss of credit.
                 </p>
                 <p>
                   <h5>Source Code</h5>
                   <a href="https://identitycloak.facitdatasystems.com/api/Containers/idcloakdownloads/download/curl-7.51.0.zip">
                     Curl</a><br>
                    <a href="https://identitycloak.facitdatasystems.com/api/Containers/idcloakdownloads/download/ffmpeg-0.8.tar.gz">
                       FFMPEG</a><br>
                    <a href="https://identitycloak.facitdatasystems.com/api/Containers/idcloakdownloads/download/libav-11.1.zip">
                         Libav</a><br>
                    <a href="https://identitycloak.facitdatasystems.com/api/Containers/idcloakdownloads/download/openssl-OpenSSL_1_0_2h.zip">
                           Openssl</a><br>
                    <a href="https://identitycloak.facitdatasystems.com/api/Containers/idcloakdownloads/download/libqxt.zip">
                             qxt</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
</template>

<script>
import FacitHeader from '@/components/header';

export default {
  name: 'legal',
  components: { FacitHeader },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/legal.vue